import { PaletteMode, SimplePaletteColorOptions } from '@mui/material';
import { warningColor } from './status/warning';

export const warning = (mode: PaletteMode): SimplePaletteColorOptions => {
  const color = warningColor(mode);
  return {
    main: color.main,
    light: mode === 'light' ? color.lowContrast : color.highContrast,
    dark: mode === 'light' ? color.highContrast : color.lowContrast,
  };
};
